import { State } from 'src/types'
import { edges } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/edge'
import { webTop, webBottom } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/web'
import { catchFace } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/catchFace'
import { thumbHook } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/hook'
import { thumbBackOut, backAroundWeb } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/thumbBack'
import { stitch } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/stitch'
import { laces } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/lace'
import { webCross } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/lace/webCross'
import { canvasResetter } from 'src/util/canvas'
import { dxmEngravedOfCatchFace } from '../../../rightThrow/glove/back/label'

export const dxmCanvasFirstMittFrontLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  if (!state.underWeb) return
  if (!state.thumb) return
  // リセット
  canvasResetter(ctx)
  ctx.translate(canvasWidth, 0)
  ctx.scale(-1, 1)

  // 革紐＿ウェブ間クロス＿上段
  webCross(ctx, state.lace.color as string, 0, 0)
  webCross(ctx, state.lace.color as string, 60, -50)
  // 革紐＿ウェブ間クロス＿下段
  webCross(ctx, state.lace.color as string, -40, -75)
  webCross(ctx, state.lace.color as string, 20, -120)
  // 捕球面
  catchFace(ctx, state.catchFace.color as string)
  // ウェブ先端側
  webTop(ctx, state.web.color as string)
  // ウェブ捕球面側
  webBottom(ctx, state.web.color as string)
  // 背面＿ウェブ周り
  backAroundWeb(ctx, state.underWeb.color as string)
  // 親指背面＿外側
  thumbBackOut(ctx, state.thumb.color as string)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color as string)
  // ヘリ革
  edges(ctx, state.edge.color as string)
  // ステッチ
  stitch(ctx, state.stitch.color as string)
  // 革紐
  laces(ctx, state.lace.color, state.materialPack)
  ctx.scale(-1, 1) // 元に戻す
  ctx.translate(-canvasWidth, 0)

  dxmEngravedOfCatchFace(ctx, state.catchFace, -60, 30)
}
